import I18n from 'I18n';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import ApiOutagePlaceholder from 'in-meeting-experience-ui-components/components/common/ApiOutagePlaceholder/ApiOutagePlaceholder';
import { ErrorContext } from 'in-meeting-experience-ui-components/contexts/error/context';
import { prettifyAppName } from 'in-meeting-experience-ui-components/utils/general';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { isLoadingSelector } from '../../slices/auth/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ErrorWrapper = ({
  children
}) => {
  const {
    isExternalOutage,
    appName,
    isApiCallObjectOutage
  } = useContext(ErrorContext);
  const isLoading = useSelector(isLoadingSelector);
  if (isLoading) return /*#__PURE__*/_jsx(LoadingOverlay, {
    contextual: true
  });
  if (isApiCallObjectOutage) {
    return /*#__PURE__*/_jsx(ApiOutagePlaceholder, {
      title: I18n.text('errors.apiCallObjectOutage.title'),
      description: I18n.text('errors.apiCallObjectOutage.description', {
        appName: prettifyAppName(appName)
      })
    });
  }
  if (isExternalOutage) {
    return /*#__PURE__*/_jsx(ApiOutagePlaceholder, {
      title: I18n.text('errors.externalOutage.title', {
        appName: prettifyAppName(appName)
      }),
      description: I18n.text('errors.externalOutage.description', {
        appName: prettifyAppName(appName)
      })
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default ErrorWrapper;